// ================= initActivity ===============
export const TempInitConfig = {
  name: 'BM-FP with fallback',
  id: 'a4f22b05-6abe-4f1d-be4c-9f2af191b385',
  key: 'REST-7',
  type: 'REST',
  arguments: {
    executionMode: '{{Context.ExecutionMode}}',
    definitionId: '{{Context.DefinitionId}}',
    activityId: '{{Activity.Id}}',
    contactKey: '{{Context.ContactKey}}',
    execute: {
      inArguments: [
        {
          receiverNum:
            '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c"}}',
        },
      ],
      url: 'https://dev-api.lets-tako.com/bulk-send',
      verb: 'POST',
      format: 'json',
      body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"260109_BM_FP_N","receiverNum":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{},"setFallback":"Y","smsOnly":"N","targeting":"I","messageSource":"SFMC_JB","bulkSendId":"01KHWZZV9642JAGGTX5FDAHG2S"}',
      headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
      timeout: 100000,
      retryCount: 5,
      retryDelay: 10000,
      concurrentRequests: 10,
    },
    testExecute: '',
    startActivityKey: '{{Context.StartActivityKey}}',
    definitionInstanceId: '{{Context.DefinitionInstanceId}}',
    requestObjectId: '{{Context.RequestObjectId}}',
  },
  configurationArguments: {
    save: '',
    testSave: '',
    publish: {
      verb: 'POST',
      url: 'https://dev-api.lets-tako.com/bye',
    },
    testPublish: '',
    unpublish: '',
    stop: '',
    testStop: '',
    testUnpublish: '',
    partnerActivityId: '',
    validate: '',
    testValidate: '',
    outArgumentSchema: '',
    executeSchema: '',
  },
  metaData: {
    icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
    category: 'message',
    original_icon: 'Tako_logo_icon.png',
    isConfigured: true,
  },
  editable: true,
  outcomes: [
    {
      key: '2995173f-6c74-46c4-9659-138ea98c18a0',
      next: 'REST-8',
      arguments: {},
      metaData: {
        invalid: false,
      },
    },
  ],
  errors: null,
};
//============requestedInteractionHandler=============
export const TempRequestedInteraction = {
  id: 'c0d3c8ba-0bae-4b8e-84e5-8dfd8cfde1ac',
  version: 5,
  useDefinitionId: false,
  name: 'BrandMessage Tests - January 11 2026 at 11.34 AM',
  description: '',
  workflowApiVersion: 1,
  entryMode: 'MultipleEntries',
  activities: [
    {
      key: 'REST-1',
      name: 'BM-FT with fallback',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: '7056614e-a5fa-4504-b300-d4474dd1cf8e',
          next: 'REST-2',
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [
            {
              receiverNum:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c"}}',
            },
            {},
            {},
            {},
            {
              fullName:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."fullName"}}',
            },
          ],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"bm_ft_test_20260109_01","receiverNum":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{"fullName":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"fullName\\"}}"},"setFallback":"Y","smsOnly":"N","targeting":"I","messageSource":"SFMC_JB","bulkSendId":"01KHWD1R3ZJT1W04TY6HHC5TJR"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
    {
      key: 'REST-2',
      name: 'BM-FI with fallback',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: '32c9f33c-4c73-4860-a7a3-bd6b4a9b2c60',
          next: 'REST-4',
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
        category: 'message',
        original_icon: 'Tako_logo_icon.png',
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [
            {
              receiverNum:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."mobileNumber"}}',
            },
            {},
            {},
            {},
            {
              clientName:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."fullName"}}',
            },
          ],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"bm_fi_test_20260112_01","receiverNum":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"mobileNumber\\"}}","templateFields":{"clientName":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"fullName\\"}}"},"setFallback":"Y","smsOnly":"N","targeting":"I","messageSource":"SFMC_JB","bulkSendId":"01KHWD2NS5T5TJ9K4A43RZY4SF"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
    {
      key: 'REST-4',
      name: 'BM-FW with fallback',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: '99d94653-75e6-43ef-94d4-c207f8f6654d',
          next: 'REST-5',
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
        category: 'message',
        original_icon: 'Tako_logo_icon.png',
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [
            {
              receiverNum:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."mobileNumber"}}',
            },
            {},
            {},
            {},
            {
              firstName:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."firstName"}}',
            },
          ],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"bm_fw_test_20251230_01","receiverNum":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"mobileNumber\\"}}","templateFields":{"firstName":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"firstName\\"}}"},"setFallback":"Y","smsOnly":"N","targeting":"I","messageSource":"SFMC_JB","bulkSendId":"01KHWD3CJ4JCYZH7EPDZTZF3NK"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
    {
      key: 'REST-5',
      name: 'BM-FL with fallback',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: '84af6225-e2cf-4904-a210-c18a762bb909',
          next: 'REST-6',
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
        category: 'message',
        original_icon: 'Tako_logo_icon.png',
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [
            {
              receiverNum:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c"}}',
            },
            {},
            {},
            {},
            {
              product1:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."product1"}}',
            },
            {
              product2:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."product2"}}',
            },
            {
              product3:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."product3"}}',
            },
          ],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"bm_fl_test_20251230_01","receiverNum":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{"product1":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"product1\\"}}","product2":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"product2\\"}}","product3":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"product3\\"}}"},"setFallback":"Y","smsOnly":"N","targeting":"I","messageSource":"SFMC_JB","bulkSendId":"01KHWD435PWTVBKH9KKA186NXK"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
    {
      key: 'REST-6',
      name: 'BM-FC with fallback',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: 'b061a754-c6a3-4a26-a28b-22a4c508d7b5',
          next: 'REST-7',
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
        category: 'message',
        original_icon: 'Tako_logo_icon.png',
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [
            {
              receiverNum:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c"}}',
            },
            {},
            {},
            {},
          ],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"bm_fc_test_20260112_02","receiverNum":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{},"setFallback":"N","targeting":"I","messageSource":"SFMC_JB","bulkSendId":"01KHWD57EQSYRT0F4MDJB2S578"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
    {
      key: 'REST-7',
      name: 'BM-FP with fallback',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: '2995173f-6c74-46c4-9659-138ea98c18a0',
          next: 'REST-8',
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
        category: 'message',
        original_icon: 'Tako_logo_icon.png',
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [
            {
              receiverNum:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c"}}',
            },
          ],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"260109_BM_FP_N","receiverNum":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{},"setFallback":"Y","smsOnly":"N","targeting":"I","messageSource":"SFMC_JB","bulkSendId":"01KHWZZV9642JAGGTX5FDAHG2S"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
    {
      key: 'REST-8',
      name: 'BM-FM with fallback',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: 'ae619123-ade6-4a8d-befb-6b9ae6f59125',
          next: 'REST-9',
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
        category: 'message',
        original_icon: 'Tako_logo_icon.png',
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [
            {
              receiverNum:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c"}}',
            },
            {},
            {},
            {},
            {
              var: '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."regularPriceTwo"}}',
            },
          ],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"250121_BM_FM","receiverNum":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{"var":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"regularPriceTwo\\"}}"},"setFallback":"N","targeting":"I","messageSource":"SFMC_JB","bulkSendId":"01KHWD7JWSX2P62BJFFY9MHT3Q"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
    {
      key: 'REST-9',
      name: 'BM-FA with fallback',
      description: '',
      type: 'REST',
      outcomes: [
        {
          key: '911b2ebf-be26-445c-9c0f-f25bf46dd7be',
          next: null,
          arguments: {},
          metaData: {
            invalid: false,
          },
        },
      ],
      metaData: {
        icon: 'https://asiance-dev.sfmc-journey.lets-tako.com/Tako_logo_icon.png',
        category: 'message',
        original_icon: 'Tako_logo_icon.png',
        isConfigured: true,
      },
      arguments: {
        executionMode: '{{Context.ExecutionMode}}',
        definitionId: '{{Context.DefinitionId}}',
        activityId: '{{Activity.Id}}',
        contactKey: '{{Context.ContactKey}}',
        execute: {
          inArguments: [
            {
              receiverNum:
                '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918."BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c"}}',
            },
            {},
            {},
            {},
          ],
          url: 'https://dev-api.lets-tako.com/bulk-send',
          verb: 'POST',
          format: 'json',
          body: '{"profileKey":"063665a78ef6dec8f1733711402b1c8adbf31d95","brandCode":"asiance","reservedTime":"00000000000000","templateCode":"20260121_fa_test","receiverNum":"{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.\\"BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c\\"}}","templateFields":{},"setFallback":"N","targeting":"I","messageSource":"SFMC_JB","bulkSendId":"01KHWD87NRXNWHG3D430AENV0P"}',
          headers: '{"x-api-key":"MfTaXHKadw2UqrTOCo5VD2yrFI768TU82vfmuzln"}',
          timeout: 100000,
          retryCount: 5,
          retryDelay: 10000,
          concurrentRequests: 10,
        },
        testExecute: '',
        startActivityKey: '{{Context.StartActivityKey}}',
        definitionInstanceId: '{{Context.DefinitionInstanceId}}',
        requestObjectId: '{{Context.RequestObjectId}}',
      },
      configurationArguments: {
        save: '',
        testSave: '',
        publish: {
          verb: 'POST',
          url: 'https://dev-api.lets-tako.com/bye',
        },
        testPublish: '',
        unpublish: '',
        stop: '',
        testStop: '',
        testUnpublish: '',
        partnerActivityId: '',
        validate: '',
        testValidate: '',
        outArgumentSchema: '',
        executeSchema: '',
        applicationExtensionKey: 'dd64e649-8423-4a62-8a42-c1fc29eee182',
      },
    },
  ],
  notifiers: [],
  persistenceModel_asyncStopping: {},
  persistenceModel_pausing: {},
  persistenceModel_resuming: {},
  metaData: {
    dataSource: 'ContactsModel',
    disableEndWait: true,
    highThroughputSending: {
      email: false,
    },
  },
  key: '261ffe46-c4e5-4bf2-8292-d9d6afbcafcd',
  createdDate: '2026-02-20T02:42:39.0000Z',
  modifiedDate: '2026-02-20T02:42:39.0000Z',
  goals: [],
  exits: [],
  definitionType: 'Multistep',
  channel: '',
  executionMode: 'Production',
  categoryId: 23793,
  definitionId: 'b7fe23e5-70e6-4441-a650-bf80bdad9d4d',
  scheduledStatus: 'Draft',
  campaigns: [],
  defaults: {
    email: [],
    mobileNumber: [],
    transactionKeys: null,
    contactErrorBehavior: {},
    properties: {
      analyticsTracking: {
        enabled: false,
        analyticsType: 'google',
        urlDomainsToTrack: [],
      },
    },
  },
  triggers: [
    {
      key: 'TRIGGER',
      name: 'TRIGGER',
      description: '',
      type: 'EmailAudience',
      arguments: {
        startActivityKey: '{{Context.StartActivityKey}}',
        dequeueReason: '{{Context.DequeueReason}}',
        lastExecutedActivityKey: '{{Context.LastExecutedActivityKey}}',
        filterResult: 'true',
      },
      configurationArguments: {
        filterDefinitionId: '00000000-0000-0000-0000-000000000000',
        criteria: '',
        schemaVersionId: 0,
      },
      metaData: {
        sourceInteractionId: '00000000-0000-0000-0000-000000000000',
        eventDefinitionId: '481C0B8B-0146-4C04-A858-5A4BCC57A2C4',
        eventDefinitionKey: 'DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918',
        chainType: 'none',
        configurationRequired: false,
        iconUrl: '/images/icon-data-extension.svg',
        title: 'Data Extension',
        entrySourceGroupConfigUrl:
          'jb:///data/entry/audience/entrysourcegroupconfig.json',
      },
    },
  ],
  transactionKeys: null,
  status: 'DRAFT',
};

//{activityDefaultValues: {...}} JourneyBuilder.tsx:43
export const tempActivityDefaultValues = {
  smsOnly: 'N',
  templateFields: {
    firstName:
      '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.firstName}}',
    greeting:
      '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.greeting}}',
  },
  messageSource: 'SFMC_JB',
  templateCode: '260109_BM_FP_N',
  reservedTime: '00000000000000',
  overrideVariables: false,
  profileKey: '063665a78ef6dec8f1733711402b1c8adbf31d95',
  targeting: 'N',
  setFallback: 'Y',
  bulkSendId: '01KHWD6SR4NFM5M1V364EKV9PT',
  receiverNum:
    '{{Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c}}',
  brandCode: 'asiance',
  allowFallback: true,
};

// =====data from requestedTriggerEventDefinition
export const SampleDataRequestedTriggerEventDefinition = {
  id: '481C0B8B-0146-4C04-A858-5A4BCC57A2C4',
  name: 'BrandMessage Tests - January 11 2026 at 11.34 AM',
  mode: 'Production',
  isVisibleInPicker: false,
  type: 'EmailAudience',
  iconUrl: '/images/icon-data-extension.svg',
  eventDefinitionKey: 'DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918',
  dataExtensionId: '19193ac6-8f08-f111-a5d5-5cba2c196e68',
  createdDate: '2026-02-19T11:08:46.9330Z',
  createdBy: 747112097,
  modifiedDate: '2026-02-19T11:08:46.9330Z',
  modifiedBy: 747112097,
  dataExtensionName: 'bm-tests-001_Copy',
  sourceApplicationExtensionId: '97e942ee-6914-4d3d-9e52-37ecb71f79ed',
  isPlatformObject: false,
  category: 'Audience',
  disableDEDataLogging: false,
  deRecordCount: 2,
  metaData: {
    scheduleState: 'No Schedule',
    criteriaDescription: null,
    scheduleFlowMode: 'runOnce',
    runOnceScheduleMode: 'onPublish',
  },
  arguments: {
    serializedObjectType: 3,
    eventDefinitionId: '481c0b8b-0146-4c04-a858-5a4bcc57a2c4',
    eventDefinitionKey: 'DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918',
    dataExtensionId: '19193ac6-8f08-f111-a5d5-5cba2c196e68',
    criteria: '',
    useHighWatermark: false,
    automationId: 'd34af620-a28c-436c-9a31-ea047fbc5dac',
  },
  configurationArguments: {
    unconfigured: false,
  },
};

// ================= requestedSchema ===============
export const SampleRequestedSchema = {
  schema: [
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.id',
      name: 'id',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: null,
      isPrimaryKey: true,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.mobileNumber',
      name: 'mobileNumber',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: null,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.fullName',
      name: 'fullName',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.asiancePath',
      name: 'asiancePath',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.firstName',
      name: 'firstName',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.lastName',
      name: 'lastName',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.greeting',
      name: 'greeting',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.product1',
      name: 'product1',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.product2',
      name: 'product2',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.product3',
      name: 'product3',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.product4',
      name: 'product4',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.eventName',
      name: 'eventName',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.lalaprice',
      name: 'lalaprice',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.sale',
      name: 'sale',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.buttonOnePath',
      name: 'buttonOnePath',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.buttonTwoPath',
      name: 'buttonTwoPath',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.commerceTitleOne',
      name: 'commerceTitleOne',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.regularPriceOne',
      name: 'regularPriceOne',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.commerceTitleTwo',
      name: 'commerceTitleTwo',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.regularPriceTwo',
      name: 'regularPriceTwo',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.commerceTitleSix',
      name: 'commerceTitleSix',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.regularPriceSix',
      name: 'regularPriceSix',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c',
      name: 'BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.BooxiEvent__cBooxiAppointmentid__rClientMobilePhone__c',
      name: 'BooxiEvent__cBooxiAppointmentid__rClientMobilePhone__c',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.BooxiEvent__c-BooxiAppointmentid__r-ClientMobilePhone__c',
      name: 'BooxiEvent__c-BooxiAppointmentid__r-ClientMobilePhone__c',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
    {
      key: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.datedate',
      name: 'datedate',
      type: 'Text',
      length: 50,
      default: null,
      isNullable: true,
      isPrimaryKey: null,
    },
  ],
};

// ===========receivedSchema===========
export const SampleDataTempReceivedSchema = [
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.id',
    label: 'id',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.mobileNumber',
    label: 'mobileNumber',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.fullName',
    label: 'fullName',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.asiancePath',
    label: 'asiancePath',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.firstName',
    label: 'firstName',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.lastName',
    label: 'lastName',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.greeting',
    label: 'greeting',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.product1',
    label: 'product1',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.product2',
    label: 'product2',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.product3',
    label: 'product3',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.product4',
    label: 'product4',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.eventName',
    label: 'eventName',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.lalaprice',
    label: 'lalaprice',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.sale',
    label: 'sale',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.buttonOnePath',
    label: 'buttonOnePath',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.buttonTwoPath',
    label: 'buttonTwoPath',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.commerceTitleOne',
    label: 'commerceTitleOne',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.regularPriceOne',
    label: 'regularPriceOne',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.commerceTitleTwo',
    label: 'commerceTitleTwo',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.regularPriceTwo',
    label: 'regularPriceTwo',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.commerceTitleSix',
    label: 'commerceTitleSix',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.regularPriceSix',
    label: 'regularPriceSix',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c',
    label: 'BooxiEvent__c:BooxiAppointmentid__r:ClientMobilePhone__c',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.BooxiEvent__cBooxiAppointmentid__rClientMobilePhone__c',
    label: 'BooxiEvent__cBooxiAppointmentid__rClientMobilePhone__c',
  },
  {
    value:
      'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.BooxiEvent__c-BooxiAppointmentid__r-ClientMobilePhone__c',
    label: 'BooxiEvent__c-BooxiAppointmentid__r-ClientMobilePhone__c',
  },
  {
    value: 'Event.DEAudience-4653f48f-f8c1-0aa3-d39a-df08a7e0c918.datedate',
    label: 'datedate',
  },
];
